/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ImplantGroup from './implant-group';
import ImplantGroupDetail from './implant-group-detail';
import ImplantGroupUpdate from './implant-group-update';
import ImplantGroupDeleteDialog from './implant-group-delete-dialog';

const ImplantGroupRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ImplantGroup />} />
    <Route path="new" element={<ImplantGroupUpdate />} />
    <Route path=":id">
      <Route index element={<ImplantGroupDetail />} />
      <Route path="edit" element={<ImplantGroupUpdate />} />
      <Route path="delete" element={<ImplantGroupDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ImplantGroupRoutes;
